import axios from 'axios'
import { useAppInfo } from '@/composables/useAppInfo'

const { getAppName, getPlatform, getAppVersion } = useAppInfo()

const restApi = axios.create({
  baseURL: get_api_base_url(),
  withCredentials: true
})

// Request interceptor to add custom headers
restApi.interceptors.request.use(
  (config) => {
    if (import.meta.env.MODE !== 'development') {
      config.headers['X-App-Name'] = getAppName();
      config.headers['X-Platform'] = getPlatform();
      config.headers['X-App-Version'] = getAppVersion();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error)
  }
)

function get_api_base_url() {
  // return api base url
  let api_base_url = ''
  if (import.meta.env.VITE_API_BASE_URL) {
    api_base_url = import.meta.env.VITE_API_BASE_URL
  } else if (import.meta.env.VITE_MOBILE_APP) {
    api_base_url = import.meta.env.VITE_MOBILE_APP_API_URL
  } else {
    api_base_url =
      location.protocol +
      '//' +
      location.host +
      (import.meta.env.VITE_API_DEV_PORT && import.meta.env.VITE_API_DEV_PORT != 80
        ? ':' + import.meta.env.VITE_API_DEV_PORT
        : '') +
      import.meta.env.VITE_API_URL_PREFIX
  }
  return api_base_url
}

restApi.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const response = error?.response
    // Expected HTTP/network outcomes — do not console.log (Sentry captureConsole noise)
    if (import.meta.env.DEV) {
      if (error.code === 'ERR_NETWORK') {
        console.debug('connection problems..')
      } else if (error.code === 'ERR_CANCELED') {
        console.debug('connection canceled..')
      }
      if (response) {
        const statusCode = response?.status
        if (statusCode === 404) {
          console.debug('The requested resource does not exist or has been deleted')
        } else if (statusCode === 401) {
          console.debug('Please login to access this resource')
        }
      }
    }
    return Promise.resolve(error.response)
  }
)

export default restApi
